import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=49bae3b3&scoped=true&"
import script from "./AddressField.vue?vue&type=script&lang=js&"
export * from "./AddressField.vue?vue&type=script&lang=js&"
import style0 from "./AddressField.vue?vue&type=style&index=0&id=49bae3b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bae3b3",
  null
  
)

export default component.exports